/* @flow */

import * as React from 'react';

import {Button, type ButtonStyleProps} from '../button';

import './floating-action-button.css';

type FloatPosition =
    | {top: number, left: number} // upper left
    | {top: number, right: number} // upper right
    | {bottom: number, right: number} // lower right
    | {bottom: number, left: number}; // lower left

type Props = {|
    ...ButtonStyleProps,
    children: React.Node,
    floatPosition?: FloatPosition,
    onClick?: () => void,
    isDisabled?: boolean,
    getButtonRef?: any,
    getContainerRef?: any,
|};

export function FloatingActionButton(props: Props) {
    const {
        children,
        floatPosition = {bottom: 0, right: 0},
        getButtonRef,
        getContainerRef,
        ...restProps
    } = props;

    return (
        <div styleName='floating-action-button' style={{...floatPosition}} ref={getContainerRef}>
            <Button {...restProps} getButtonRef={getButtonRef}>
                {children}
            </Button>
        </div>
    );
}
